/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { TestCallRequest } from '../models';
// @ts-ignore
import type { TestCallResponse } from '../models';
/**
 * TestCallsApi - axios parameter creator
 * @export
 */
export const TestCallsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestCallsHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/test-calls/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestCallsHealthGet_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/test-calls/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestCallApiV1TestCallsInitiateAgentIdPost: async (agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateTestCallApiV1TestCallsInitiateAgentIdPost', 'agentId', agentId)
            // verify required parameter 'testCallRequest' is not null or undefined
            assertParamExists('initiateTestCallApiV1TestCallsInitiateAgentIdPost', 'testCallRequest', testCallRequest)
            const localVarPath = `/api/v1/test-calls/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testCallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestCallApiV1TestCallsInitiateAgentIdPost_2: async (agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('initiateTestCallApiV1TestCallsInitiateAgentIdPost_2', 'agentId', agentId)
            // verify required parameter 'testCallRequest' is not null or undefined
            assertParamExists('initiateTestCallApiV1TestCallsInitiateAgentIdPost_2', 'testCallRequest', testCallRequest)
            const localVarPath = `/api/v1/test-calls/initiate/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xAPIKey != null) {
                localVarHeaderParameter['X-API-Key'] = String(xAPIKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testCallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestCallsApi - functional programming interface
 * @export
 */
export const TestCallsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestCallsApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1TestCallsHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1TestCallsHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCallsApi.healthCheckApiV1TestCallsHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckApiV1TestCallsHealthGet_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckApiV1TestCallsHealthGet_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCallsApi.healthCheckApiV1TestCallsHealthGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId, testCallRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCallsApi.initiateTestCallApiV1TestCallsInitiateAgentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId, testCallRequest, authorization, xAPIKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestCallsApi.initiateTestCallApiV1TestCallsInitiateAgentIdPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestCallsApi - factory interface
 * @export
 */
export const TestCallsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestCallsApiFp(configuration)
    return {
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestCallsHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1TestCallsHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint for test calls service.  Returns:     Simple health status
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckApiV1TestCallsHealthGet_1(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckApiV1TestCallsHealthGet_1(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TestCallResponse> {
            return localVarFp.initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId, testCallRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
         * @summary Initiate Test Call
         * @param {string} agentId 
         * @param {TestCallRequest} testCallRequest 
         * @param {string | null} [authorization] 
         * @param {string | null} [xAPIKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TestCallResponse> {
            return localVarFp.initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId, testCallRequest, authorization, xAPIKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestCallsApi - object-oriented interface
 * @export
 * @class TestCallsApi
 * @extends {BaseAPI}
 */
export class TestCallsApi extends BaseAPI {
    /**
     * Health check endpoint for test calls service.  Returns:     Simple health status
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCallsApi
     */
    public healthCheckApiV1TestCallsHealthGet(options?: RawAxiosRequestConfig) {
        return TestCallsApiFp(this.configuration).healthCheckApiV1TestCallsHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint for test calls service.  Returns:     Simple health status
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCallsApi
     */
    public healthCheckApiV1TestCallsHealthGet_1(options?: RawAxiosRequestConfig) {
        return TestCallsApiFp(this.configuration).healthCheckApiV1TestCallsHealthGet_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
     * @summary Initiate Test Call
     * @param {string} agentId 
     * @param {TestCallRequest} testCallRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCallsApi
     */
    public initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestCallsApiFp(this.configuration).initiateTestCallApiV1TestCallsInitiateAgentIdPost(agentId, testCallRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate a test call for direct frontend-to-LiveKit connection.  This endpoint creates an ephemeral test call without database persistence. It generates a LiveKit room and access token for the frontend to connect directly via WebRTC, bypassing Twilio SIP infrastructure.  **Purpose**: Simplifies prompt engineering and agent testing during development.  **Authentication**: Requires JWT token or API key with \'call:test\' permission.  **Key Features**: - No CallLog database entries (ephemeral, lightweight) - Direct WebRTC connection (no SIP) - 2-hour token expiration - Supports any agent type for testing  Args:     agent_id: UUID of the agent to test     request: Test call request with optional metadata  Returns:     TestCallResponse with room details and access token  Raises:     ForbiddenError: If missing permission     NotFoundError: If agent not found     BadRequestError: If agent invalid     InternalError: On service failure
     * @summary Initiate Test Call
     * @param {string} agentId 
     * @param {TestCallRequest} testCallRequest 
     * @param {string | null} [authorization] 
     * @param {string | null} [xAPIKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestCallsApi
     */
    public initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId: string, testCallRequest: TestCallRequest, authorization?: string | null, xAPIKey?: string | null, options?: RawAxiosRequestConfig) {
        return TestCallsApiFp(this.configuration).initiateTestCallApiV1TestCallsInitiateAgentIdPost_2(agentId, testCallRequest, authorization, xAPIKey, options).then((request) => request(this.axios, this.basePath));
    }
}

